import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import updatePageNumber from '~/helpers/pagination-helper';
import { productIndex } from '~/const/listing/algolia';

var PendingTag = function PendingTag() {
  return import('~/components/functional/TcVars/PendingTag.vue');
};

var ProductItem = function ProductItem() {
  return import(
  /* webpackChunkName: "product" */
  '~/components/library/Product/ProductItem.vue');
};

var PRODUCT_PER_PAGE = 40;
export default {
  name: 'CategoryProductList',
  components: {
    ProductItem: ProductItem,
    PendingTag: PendingTag
  },
  props: {
    algolia: {
      type: Boolean,
      default: false
    },
    previousPage: {
      type: Number,
      required: true
    },
    commercial: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    isCategoryTemplate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    trackingMeaClick: function trackingMeaClick() {
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Click_MEA',
          event_label: "".concat(this.commercial.mea_banner.title)
        }
      };
    },
    trackingMeaDisplay: function trackingMeaDisplay() {
      return typeof window !== 'undefined' ? {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Display_MEA',
          event_label: "".concat(this.commercial.mea_banner.title)
        }
      } : {};
    },
    predicateCommercial: function predicateCommercial() {
      var hasCommercial = false;

      if (this.commercial) {
        hasCommercial = this.commercial.mea_banner && this.commercial.mea_banner.image;
      }

      return hasCommercial;
    }
  },
  methods: {
    productClick: function productClick(position, product) {
      var query = this.$route.query;
      query.page = Math.floor(position / PRODUCT_PER_PAGE) + this.previousPage;
      updatePageNumber(query);
      localStorage.setItem('currentProduct', JSON.stringify("product-".concat(product.reference)));

      if (this.algolia) {
        try {
          var payload = {
            userToken: this.$cookies.get('_ALGOLIA'),
            index: productIndex,
            queryID: product.queryID,
            objectIDs: [product.reference]
          };
          window.aa('clickedObjectIDsAfterSearch', _objectSpread({}, payload, {
            eventName: 'product_click_on_search_page',
            positions: [product.position]
          }));
          localStorage.setItem('algoliaLastEvent', JSON.stringify(payload));
        } catch (err) {
          console.log(err);
        }
      }
    },
    trackingProduct: function trackingProduct(product) {
      if (this.algolia) {
        return {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: "Algolia_Produit_".concat(product.reference)
          }
        };
      }

      return {
        fn: 'product_list_click',
        data: {
          product_id: product.reference,
          position: product.position,
          category_click: ''
        }
      };
    }
  }
};